export default "__VITE_ASSET__CWQRXF$m__"